import React from 'react';
import PropTypes from 'prop-types';

import { SAVINGS_MONTHLY_BALANCES } from '@ratehub/inv-common';

import HeadingPropTypes from '../definitions/HeadingPropTypes';
import PAGE_TEMPLATES from '../definitions/PageTemplates';
import SavingsAccountPropType from '../definitions/SavingsAccountPropType';
import getSavingsAccountProps from '../functions/getSavingsAccountProps';
import useSavingsInterestCalculationCallback from '../hooks/useSavingsInterestCalculationCallback';
import HeadingBlock from './HeadingBlock';
import ProductCardWithBigNumberBox from './ProductCardWithBigNumberBox';


function ProductSingleSavings({
    heading,
    savingsAccount,
    monthlyBalance = SAVINGS_MONTHLY_BALANCES[1],    // $5,000
    ...otherProps
}) {
    const showCalculationModalCallback = useSavingsInterestCalculationCallback();

    return (
        // If slot is nullish (usually because the product is deprecated), don't render anything.
        // This is to ensure legacy pages with deprecated products don't prevent exporter from running.
        <If condition={savingsAccount} >
            <div {...otherProps}>
                <If condition={heading}>
                    <HeadingBlock
                        {...heading}
                    />
                </If>

                <ProductCardWithBigNumberBox
                    product={getSavingsAccountProps({
                        savingsAccount,
                        monthlyBalance,
                        bigNumberClick: () => showCalculationModalCallback({ savingsAccount, monthlyBalance }),
                    })}
                />
            </div>
        </If>
    );
}

ProductSingleSavings.propTypes = {
    heading: HeadingPropTypes,
    savingsAccount: SavingsAccountPropType,
    monthlyBalance: PropTypes.number,
};


ProductSingleSavings.blockKey = 'rh/product-single-savings';
ProductSingleSavings.hasHeading = true;
ProductSingleSavings.requiresLayoutRow = true;
ProductSingleSavings.supportedPageTypes = [ PAGE_TEMPLATES.savings ];


export default ProductSingleSavings;
